// extracted by mini-css-extract-plugin
export default {"cont":"Loader_cont__io9G6","logo":"Loader_logo__6tmOH"};